($ => {
  var mqls = [window.matchMedia('(max-width: 700px)')];

  function applyAccessibilityBindings($accordion) {
    // Apply the same accessibility enhancements as getwid-accessibility-enhancements.php
    const emExcludeElements = 'p,div,span,strong,ul,ol,li,em,br,figure,img';

    const processElements = $container => {
      const allElements = $container.find('*');
      return allElements.filter(function () {
        const $el = $(this);
        const isExcluded = $el.is(emExcludeElements);
        const isInteractive = $el.is(
          'a,button,input,select,textarea,[tabindex]'
        );
        return !isExcluded && (isInteractive || !$el.is(emExcludeElements));
      });
    };

    // Set tabindex on headers
    $accordion
      .find('.wp-block-getwid-accordion__header-wrapper')
      .attr('tabindex', 0);

    // Set inert on content wrappers
    const activeElement = $accordion.data('active-element');
    const activeIndex =
      activeElement !== 'none' && activeElement !== undefined
        ? parseInt(activeElement, 10)
        : -1;

    $accordion
      .find('.wp-block-getwid-accordion__content-wrapper')
      .each(function (index) {
        const $wrapper = $(this);
        if (index !== activeIndex) {
          $wrapper.attr('inert', '');
          processElements($wrapper).attr('tabindex', -1);
        }
      });

    // Process header elements
    $accordion.find('.wp-block-getwid-accordion__header').each(function () {
      processElements($(this)).attr('tabindex', -1);
    });

    // Bind click and keydown events for scroll-into-view
    $accordion
      .find('.wp-block-getwid-accordion__header-wrapper')
      .on('click keydown', function (event) {
        if (
          event.type === 'click' ||
          (event.type === 'keydown' &&
            event.key !== 'Tab' &&
            event.key !== 'Shift')
        ) {
          // Override getwid code that sets headers to -1 on click
          $('.wp-block-getwid-accordion__header-wrapper').attr('tabindex', 0);

          const $this = $(this);
          const $content = $this.next(
            '.wp-block-getwid-accordion__content-wrapper'
          );
          const isExpanding = $this[0].outerHTML.includes(
            'aria-expanded="true"'
          );

          if (isExpanding) {
            // Opened state
            setTimeout(() => {
              $this
                .find('a')[0]
                .scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 500);

            $content.removeAttr('inert');
            processElements($content).attr('tabindex', 0);

            $content.find('iframe').each(function () {
              processElements($(this).contents()).attr('tabindex', 0);
            });

            $this
              .siblings('.wp-block-getwid-accordion__header-wrapper')
              .next('.wp-block-getwid-accordion__content-wrapper')
              .each(function () {
                const $siblingContent = $(this);
                processElements($siblingContent).attr('tabindex', -1);
                $siblingContent.find('iframe').each(function () {
                  processElements($(this).contents()).attr('tabindex', -1);
                });
              });
          } else {
            // Closed state
            $content.attr('inert', '');
            processElements($content).attr('tabindex', -1);

            $content.find('iframe').each(function () {
              processElements($(this).contents()).attr('tabindex', -1);
            });

            $this
              .siblings('.wp-block-getwid-accordion__header-wrapper')
              .next('.wp-block-getwid-accordion__content-wrapper')
              .each(function () {
                const $siblingContent = $(this);
                processElements($siblingContent).attr('tabindex', -1);
                $siblingContent.find('iframe').each(function () {
                  processElements($(this).contents()).attr('tabindex', -1);
                });
              });
          }
        }
      });
  }

  function initAccordion($element) {
    // Initialize accordion using Getwid's settings
    const activeElement = $element.data('active-element');
    const activeIndex =
      activeElement !== 'none' && activeElement !== undefined
        ? parseInt(activeElement, 10)
        : false;

    $element.accordion({
      icons: false,
      animate: false,
      collapsible: true,
      active: activeIndex,
      heightStyle: 'content',
      create: () => {
        // Empty create handler
      },
      activate: (_event, ui) => {
        if (ui.newPanel.length) {
          const newHeight = ui.newPanel
            .find('.wp-block-getwid-accordion__content')
            .outerHeight(true);
          if (newHeight) {
            $(ui.newPanel).animate(
              {
                height: newHeight
              },
              {
                queue: false,
                duration: 500,
                complete: function () {
                  $(this).css('height', '');
                }
              }
            );
          }
        }
        if (ui.oldPanel.length) {
          const oldHeight = ui.oldPanel
            .find('.wp-block-getwid-accordion__content')
            .outerHeight(true);
          if (oldHeight) {
            $(ui.oldPanel).css('height', oldHeight);
            $(ui.oldPanel).animate(
              {
                height: 0
              },
              {
                queue: false,
                duration: 500,
                complete: function () {
                  $(this).css('height', '');
                }
              }
            );
          }
        }
      }
    });

    // Apply accessibility bindings after initialization
    applyAccessibilityBindings($element);
  }

  function createAccordionFromTabs($tabsContainer) {
    // Check if accordion already exists
    if ($tabsContainer.next('.getwid-tabs-accordion-clone').length) {
      return $tabsContainer.next('.getwid-tabs-accordion-clone');
    }

    // Create new accordion container
    const $accordion = $('<div>')
      .addClass(
        'wp-block-getwid-accordion has-icon-left getwid-tabs-accordion-clone'
      )
      .attr('role', 'tablist');

    // Copy active element data
    const activeTab = $tabsContainer.data('active-tab');
    if (activeTab) {
      $accordion.data('active-element', activeTab);
    }

    // Get all tabs and their content
    const tabs = [];
    $tabsContainer
      .find('.wp-block-getwid-tabs__nav-link')
      .each((index, navLink) => {
        const $navLink = $(navLink);
        const $title = $navLink.find('.wp-block-getwid-tabs__title');
        const tabId = $navLink.attr('aria-controls');
        const $contentWrapper = $tabsContainer.find(`#${tabId}`);

        // Try multiple selectors to find content - tabs might not be fully initialized
        let $content = $contentWrapper.find(
          '.wp-block-getwid-tabs__tab-content'
        );

        // If content wrapper doesn't exist yet, try finding by ID directly
        if (!$contentWrapper.length) {
          const $directContent = $(`#${tabId}`);
          if ($directContent.length) {
            $content = $directContent.find(
              '.wp-block-getwid-tabs__tab-content'
            );
          }
        }

        // Get the actual HTML content
        let contentHtml = '';
        if ($content.length) {
          contentHtml = $content.html() || '';
        } else if ($contentWrapper.length) {
          // Fallback: use the wrapper's content directly
          contentHtml = $contentWrapper.html() || '';
        }

        tabs.push({
          index: index,
          title: $title.text(),
          contentHtml: contentHtml,
          tabId: tabId
        });
      });

    // Build accordion structure
    tabs.forEach(tab => {
      // Create header
      const $header = $('<div>')
        .addClass('wp-block-getwid-accordion__header-wrapper')
        .attr('data-tab-id', tab.tabId)
        .append(
          $('<span>')
            .addClass('wp-block-getwid-accordion__header')
            .append(
              $('<a>')
                .attr('href', '#')
                .attr('tabindex', '-1')
                .append(
                  $('<span>')
                    .addClass('wp-block-getwid-accordion__header-title')
                    .text(tab.title)
                )
                .append(
                  '<span class="wp-block-getwid-accordion__icon is-active"><i class="fas fa-plus" tabindex="-1"></i></span>'
                )
                .append(
                  '<span class="wp-block-getwid-accordion__icon is-passive"><i class="fas fa-minus" tabindex="-1"></i></span>'
                )
            )
        );

      // Create content wrapper
      const $contentWrapper = $('<div>')
        .addClass('wp-block-getwid-accordion__content-wrapper')
        .attr('data-tab-id', tab.tabId)
        .append(
          $('<div>')
            .addClass('wp-block-getwid-accordion__content')
            .html(tab.contentHtml)
        );

      // Append to accordion
      $accordion.append($header).append($contentWrapper);
    });

    // Insert accordion after tabs container
    $accordion.insertAfter($tabsContainer);

    return $accordion;
  }

  function showAccordion($tabsContainer) {
    // Hide tabs and make inaccessible
    $tabsContainer
      .css({
        display: 'none',
        visibility: 'hidden',
        'pointer-events': 'none'
      })
      .attr('aria-hidden', 'true')
      .addClass('getwid-tabs-hidden-for-accordion');

    // Get or create accordion
    let $accordion = $tabsContainer.next('.getwid-tabs-accordion-clone');
    if (!$accordion.length) {
      $accordion = createAccordionFromTabs($tabsContainer);
    }

    // Show accordion
    $accordion
      .css({
        display: 'block',
        visibility: 'visible',
        'pointer-events': 'auto'
      })
      .removeAttr('aria-hidden');

    // Initialize accordion if not already initialized
    if (!$accordion.hasClass('ui-accordion')) {
      initAccordion($accordion);
    }
  }

  function showTabs($tabsContainer) {
    // Show tabs and make accessible
    $tabsContainer
      .css({
        display: '',
        visibility: '',
        'pointer-events': ''
      })
      .removeAttr('aria-hidden')
      .removeClass('getwid-tabs-hidden-for-accordion');

    // Hide accordion if it exists
    const $accordion = $tabsContainer.next('.getwid-tabs-accordion-clone');
    if ($accordion.length) {
      // Destroy accordion widget
      if ($accordion.hasClass('ui-accordion')) {
        $accordion.accordion('destroy');
      }

      $accordion
        .css({
          display: 'none',
          visibility: 'hidden',
          'pointer-events': 'none'
        })
        .attr('aria-hidden', 'true');
    }
  }

  function mediaqueryresponse() {
    // Process all tabs blocks (never touch real accordions)
    $('.wp-block-getwid-tabs').each((_i, e) => {
      const $tabsContainer = $(e);

      if (mqls[0].matches) {
        // Mobile: Show accordion, hide tabs
        showAccordion($tabsContainer);
      } else {
        // Desktop: Show tabs, hide accordion
        showTabs($tabsContainer);
      }
    });
  }

  $(document).ready(() => {
    // Wait for Getwid tabs to initialize before running our transformation
    // Getwid initialization happens after DOM ready
    setTimeout(() => {
      mqls.forEach((_e, i) => {
        mediaqueryresponse(mqls[i]);
        mqls[i].addEventListener('change', mediaqueryresponse);
      });
    }, 100);
  });
})(jQuery);
